import script from "./VideoProject.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoProject.vue?vue&type=script&setup=true&lang=js"

import "./VideoProject.vue?vue&type=style&index=0&id=7a10c774&scoped=true&lang=css"
import "./VideoProject.vue?vue&type=style&index=1&id=7a10c774&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a10c774"]])

export default __exports__